"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderProcessingStatusNameEnum = exports.OrderProcessingStatusEnum = void 0;
var OrderProcessingStatusEnum;
(function (OrderProcessingStatusEnum) {
    OrderProcessingStatusEnum["NEW"] = "NEW";
    OrderProcessingStatusEnum["IN_WORK"] = "IN_WORK";
    OrderProcessingStatusEnum["PROCESSED"] = "PROCESSED";
    OrderProcessingStatusEnum["IN_IIKO"] = "IN_IIKO";
})(OrderProcessingStatusEnum = exports.OrderProcessingStatusEnum || (exports.OrderProcessingStatusEnum = {}));
var OrderProcessingStatusNameEnum;
(function (OrderProcessingStatusNameEnum) {
    OrderProcessingStatusNameEnum["NEW"] = "\u041D\u043E\u0432\u044B\u0439";
    OrderProcessingStatusNameEnum["IN_WORK"] = "\u0412 \u0440\u0430\u0431\u043E\u0442\u0435";
    OrderProcessingStatusNameEnum["PROCESSED"] = "\u041E\u0442\u043C\u0435\u043D\u0435\u043D";
    OrderProcessingStatusNameEnum["IN_IIKO"] = "\u0412 \u0430\u0439\u043A\u043E";
})(OrderProcessingStatusNameEnum = exports.OrderProcessingStatusNameEnum || (exports.OrderProcessingStatusNameEnum = {}));
//# sourceMappingURL=OrderProcessingStatusEnum.js.map